export default {
  title: 'Mot de passe oublié',
  email: 'Votre adresse email',
  emailWarning: 'Veuillez renseigner une adresse email valide',
  login: 'Se connecter',
  submit: 'Réinitialiser le mot de passe',
  registerText: 'Besoin d\'un compte Nextories ?',
  registerBtn: 'Créer un compte',
  success: {
    title: 'Email envoyé',
    text: 'Un email vous a été envoyé avec les instructions pour réinitialiser votre mot de passe.',
  },
  error: {
    title: 'Erreur d\'email',
    text: 'On dirait que vous avez entré une adresse email erronée... Essayez de nouveau !',
  },
};
